var _rect, _rect2, _rect3, _rect4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedTreatment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 58,
    viewBox: "0 0 59 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 57.1437,
    height: 56.4667,
    rx: 10.5,
    fill: "white",
    stroke: "#6FA34E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.77148,
    y: 9.66633,
    width: 23.6856,
    height: 23.4,
    fill: "url(#pattern0)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 22.3265,
    height: 22.417,
    transform: "matrix(0.582007 0.813184 -0.819788 0.572667 33.4141 18.3337)",
    fill: "url(#pattern1)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 21.762,
    height: 21.8502,
    transform: "matrix(0.582007 0.813184 -0.819788 0.572667 43.4746 7.06633)",
    fill: "url(#pattern2)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_130",
    transform: "matrix(0.015625 0 0 0.0158157 0 -0.00610323)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_130",
    transform: "matrix(0.0156883 0 0 0.015625 -0.00202626 0)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1_130",
    transform: "matrix(0.0156883 0 0 0.015625 -0.00202628 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1_130",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedTreatment);
export default __webpack_public_path__ + "static/media/SeedTreatment.b4dfed2567be29373305ca5636c92d2f.svg";
export { ForwardRef as ReactComponent };